// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2309747c","85":"62ca7d93","206":"ffb87880","222":"0a1e9ea8","229":"af2d2c03","347":"81e04e84","408":"9e620e14","409":"4f9ad5ae","602":"236a3b54","787":"e66b5992","791":"a624bf93","906":"a7bab46d","916":"234b030e"}[chunkId] + ".chunk.js";
};